import { render, staticRenderFns } from "./numberLabel.vue?vue&type=template&id=90c20616&scoped=true&"
import script from "./numberLabel.vue?vue&type=script&lang=js&"
export * from "./numberLabel.vue?vue&type=script&lang=js&"
import style0 from "./numberLabel.vue?vue&type=style&index=0&id=90c20616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c20616",
  null
  
)

export default component.exports